import { useState } from 'react';
import { Tabs, Table } from '@mantine/core';
import { useSelector } from 'react-redux';

const tabConfig = ['lastMonth', 'last3Months'].map((key) => {
  return {
    key,
    name: key.replace('last', 'Last ').replace('Month', ' Month'),
  };
});

const ProductStatsCard = ({ stats }) => {
  const [key, setKey] = useState(tabConfig[0].key);
  const { domain } = useSelector((state) => state.domain);

  const formatCurrency = (val) => {
    if (val === null || val === undefined) {
      return val;
    }
    return val.toLocaleString(navigator.language, { style: 'currency', currency: domain.currency });
  };

  if (stats === undefined) {
    return '';
  }

  return (
    <>
      <Tabs value={key} onChange={setKey}>
        <Tabs.List>
          {tabConfig.map(({ key, name }) => (
            <Tabs.Tab key={key} value={key}>
              {name}
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs>
      <br />
      <Table striped highlightOnHover withTableBorder>
        <Table.Tbody>
          <Table.Tr>
            <Table.Th>Orders</Table.Th>
            <Table.Td>{stats[key].orders.toLocaleString(navigator.language)}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Th>Ordered amount</Table.Th>
            <Table.Td>{stats[key].orderedAmount.toLocaleString(navigator.language)}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Th>Revenue</Table.Th>
            <Table.Td>{formatCurrency(stats[key].revenue)}</Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </>
  );
};

export default ProductStatsCard;
